export enum SymptomTrackerRoutesEnum {
  ROOT = "/symptom-tracker",
  "ADD_SYMPTOM" = "/symptom-tracker/add-symptoms",
}

export enum SymptomTrackerPathsEnum {
  ROOT = "symptom-tracker",
  ADD_SYMPTOM = "add-symptoms",
}
